import React, { Component } from 'react';

import './styles.css';

class Input extends Component {
  render() {
    const {
      label,
      name
    } = this.props;

    return (
      <label htmlFor={name} className="InputLabel">
        {label}
        <input
          className={`Input ${this.props.className || ''}`}
          {...this.props}
        />
      </label>
    );
  }
}

export default Input;
